var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/pending-yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/pending-yellow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "on"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "space",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.4042692,13.0816799 L12.0838109,13.0816799 C11.4873885,13.0816799 11.0036964,12.5979878 11.0036964,12.0015654 L11.0036964,6.96146764 C11.0036964,6.36504515 11.4873885,5.88135307 12.0838109,5.88135307 C12.6802334,5.88135307 13.1639255,6.36504515 13.1639255,6.96146764 L13.1639255,10.5622865 C13.1639255,10.7602201 13.3251562,10.9214508 13.5244006,10.9214508 L16.4042692,10.9214508 C17.0006917,10.9214508 17.4843838,11.4051429 17.4843838,12.0015654 C17.4843838,12.5979878 17.0006917,13.0816799 16.4042692,13.0816799 M15.4460608,3.68573182 C12.0825001,2.2923316 8.21165264,3.06178215 5.63720481,5.63622998 C3.06275698,8.20936699 2.29199561,12.0802145 3.68539584,15.4437751 C5.07748525,18.8073358 8.35977515,21.0003354 12.0012294,21.0003354 C16.9679212,20.9950921 20.9934453,16.969568 21,12.0015654 C21.0013102,8.36142196 18.8083106,5.07913205 15.4460608,3.68573182",
    id: "Fill-5",
    fill: "#FFC418"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.b445cd03e5b1937c36ae26bc0c704c65.svg";
export { ForwardRef as ReactComponent };